/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { AudioRequestBuilderNavigationMetadata, AudioRequestBuilderRequestsMetadata, type AudioRequestBuilder } from './audio/index.js';
// @ts-ignore
import { CropRequestBuilderRequestsMetadata, type CropRequestBuilder } from './crop/index.js';
// @ts-ignore
import { FaceBlurRequestBuilderRequestsMetadata, type FaceBlurRequestBuilder } from './faceBlur/index.js';
// @ts-ignore
import { RemoveAudioRequestBuilderRequestsMetadata, type RemoveAudioRequestBuilder } from './removeAudio/index.js';
// @ts-ignore
import { RotateRequestBuilderRequestsMetadata, type RotateRequestBuilder } from './rotate/index.js';
// @ts-ignore
import { ScreenshotRequestBuilderRequestsMetadata, type ScreenshotRequestBuilder } from './screenshot/index.js';
// @ts-ignore
import { StaticBlurRequestBuilderRequestsMetadata, type StaticBlurRequestBuilder } from './staticBlur/index.js';
// @ts-ignore
import { TrimRequestBuilderRequestsMetadata, type TrimRequestBuilder } from './trim/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /files/{file-id}/revisions/{revisionId}/edit
 */
export interface EditRequestBuilder extends BaseRequestBuilder<EditRequestBuilder> {
    /**
     * The audio property
     */
    get audio(): AudioRequestBuilder;
    /**
     * The crop property
     */
    get crop(): CropRequestBuilder;
    /**
     * The faceBlur property
     */
    get faceBlur(): FaceBlurRequestBuilder;
    /**
     * The removeAudio property
     */
    get removeAudio(): RemoveAudioRequestBuilder;
    /**
     * The rotate property
     */
    get rotate(): RotateRequestBuilder;
    /**
     * The screenshot property
     */
    get screenshot(): ScreenshotRequestBuilder;
    /**
     * The staticBlur property
     */
    get staticBlur(): StaticBlurRequestBuilder;
    /**
     * The trim property
     */
    get trim(): TrimRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const EditRequestBuilderUriTemplate = "{+baseurl}/files/{file%2Did}/revisions/{revisionId}/edit";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const EditRequestBuilderNavigationMetadata: Record<Exclude<keyof EditRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    audio: {
        requestsMetadata: AudioRequestBuilderRequestsMetadata,
        navigationMetadata: AudioRequestBuilderNavigationMetadata,
    },
    crop: {
        requestsMetadata: CropRequestBuilderRequestsMetadata,
    },
    faceBlur: {
        requestsMetadata: FaceBlurRequestBuilderRequestsMetadata,
    },
    removeAudio: {
        requestsMetadata: RemoveAudioRequestBuilderRequestsMetadata,
    },
    rotate: {
        requestsMetadata: RotateRequestBuilderRequestsMetadata,
    },
    screenshot: {
        requestsMetadata: ScreenshotRequestBuilderRequestsMetadata,
    },
    staticBlur: {
        requestsMetadata: StaticBlurRequestBuilderRequestsMetadata,
    },
    trim: {
        requestsMetadata: TrimRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
